// extracted by mini-css-extract-plugin
var _1 = "Notifications__Close___eMVZN";
var _2 = "Notifications__Notification___Vlj7Y";
var _3 = "Notifications__Notifications___c5mJD";
var _4 = "Notifications__message___qcL1v";
var _5 = "Notifications__wiggle___GUfDE";
export { _1 as "Close", _2 as "Notification", _3 as "Notifications", _4 as "message", _5 as "wiggle" }
